import React, { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

// Theme values: 'light', 'dark'
export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("theme") || "light";
  });

  useEffect(() => {
    const root = document.documentElement;
    root.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const cycleTheme = () => {
    setTheme((current) => {
      if (current === "light") return "dark";
      return "light";
    });
  };

  // Get the effective theme (what's actually showing)
  const getEffectiveTheme = () => theme;

  return (
    <ThemeContext.Provider value={{ theme, setTheme, cycleTheme, getEffectiveTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within ThemeProvider");
  }
  return context;
};
